import { numComma } from '../../utils/number';

const VueNumberFilter = {
    install(Vue) {
        Vue.filter('numComma', numComma);
    }
};

export default VueNumberFilter;
